<h2 mat-dialog-title id="koble-brukere-dialog-tittel">{{ 'Koble bruker {navn}' | translate:{navn: bruker()?.navnEllerEpost} }}</h2>
<mat-dialog-content>
  @if (bruker(); as beholdes) {
    <div class="brukere">
      <section>
        <h3>{{ 'Bruker som beholdes' | translate }}</h3>
        <ng-container [ngTemplateOutlet]="brukerdata" [ngTemplateOutletContext]="{$implicit: beholdes, medlemskap: medlemskap()}"></ng-container>
      </section>
      <section>
        @if (brukerSomSlettes(); as slettes) {
          <h3>{{ 'Bruker som slettes' | translate }}</h3>
          <ng-container [ngTemplateOutlet]="brukerdata" [ngTemplateOutletContext]="{$implicit: slettes, medlemskap: medlemskapSomSlettes()}"></ng-container>
          <p class="advarsel">{{ 'NB! Brukeren {brukernavn} slettes! Medlemskap flyttes over til {beholdes}' | translate:{brukernavn: slettes.brukernavn, beholdes: beholdes.brukernavn} }}</p>
        } @else {
          <h3>{{ 'Søk etter bruker som skal kobles' | translate }}</h3>
          <mat-form-field><mat-label>{{ 'Brukernavn' | translate }}</mat-label><input matInput [formControl]="brukernavn"></mat-form-field>
          <button mat-raised-button color="primary" type="button" [disabled]="brukernavn.invalid" (click)="sokEtterBruker()">{{ 'Hent' | translate }}</button>
          @if (ikkeFunnet()) { <p class="feil">{{ 'Det ble ikke funnet noen bruker med brukernavn {brukernavn}.' | translate:{brukernavn: brukernavn.value} }}</p> }
        }
      </section>
    </div>
  }
  @if (valideringsfeil()?.harFeil) { <p class="feil">{{ 'Brukere kan ikke være medlem i samme gruppe' | translate }}</p> }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" type="button" [disabled]="brukerSomSlettes() === null" [visSpinner]="lagrer()" (click)="koble()">{{ 'Koble' | translate }}</button>
  <button mat-button type="button" (click)="avbryt()">{{ 'Avbryt' | translate }}</button>
</mat-dialog-actions>

<ng-template #brukerdata let-bruker let-medlemskap="medlemskap">
  <p>{{ 'Navn' | translate }}: {{ bruker.navn }}</p><p>{{ 'Brukernavn' | translate }}: {{ bruker.brukernavn }}</p><p>{{ 'Epost' | translate }}: {{ bruker.epost }}</p>
  <p>{{ 'Autentiseringsmetoder' | translate }}: {{ autentiseringsmetoder(bruker).join(', ') }}</p>
  <p>{{ 'Medlemskap' | translate }}:</p><ul>@for (medlem of medlemskap; track medlem.id) { <li>{{ medlem.gruppe.organisasjonsnavn }} - {{ medlem.gruppe.tittel }}</li> }</ul>
</ng-template>
